var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"top"},[_c('search'),_c('brands'),_c('price')],1),_c('div',{staticClass:"bottom"},[_c('tab')],1),_c('footer',[_c('foot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }